<template>
  <!-- 珠宝商品 -->
  <div class="app-container">
    <div class="app_content" v-loading="loading">
      <div style="display: flex; flex-wrap: wrap;">
        <el-input v-model="query.name" :placeholder="$language('商品名称')" clearable
          style="width: 220px;margin-right: 10px;margin-bottom: 10px;" />
        <el-select v-model="query.pricing_type" :placeholder="$language('计价类型')" clearable
          style="margin-right: 10px;margin-bottom: 10px;"
          :style="{ 'width': $store.getters.language == 'EN' ? '220px' : '140px' }">
          <el-option :label="$language('一口价')" :value="1"></el-option>
          <el-option :label="$language('金工石计价')" :value="2"></el-option>
        </el-select>
        <el-select v-model="query.status" :placeholder="$language('状态')" clearable
          style="margin-right: 10px;margin-bottom: 10px;"
          :style="{ 'width': $store.getters.language == 'EN' ? '160px' : '140px' }">
          <el-option :label="$language('上架')" :value="1"></el-option>
          <el-option :label="$language('下架')" :value="0"></el-option>
        </el-select>
        <el-select v-model="query.jewelry_brand_id" :placeholder="$language('品牌')" clearable
          style="width: 140px;margin-right: 10px;margin-bottom: 10px;">
          <el-option v-for="(item, index) in brandList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select v-model="query.is_hot" :placeholder="$language('热门')" clearable
          style="width: 120px;margin-right: 10px;margin-bottom: 10px;">
          <el-option :label="$language('热门')" value="1"></el-option>
          <el-option :label="$language('非热门')" value="0"></el-option>
        </el-select>
        <el-date-picker v-model="search_time" type="datetimerange" :picker-options="pickerOptions"
          :range-separator="$language('至')" :start-placeholder="$language('创建开始时间')"
          :end-placeholder="$language('创建结束时间')" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"
          align="right" clearable style="margin-right: 10px;margin-bottom: 10px;" @change="change_time"
          @focus="dateFocus">
        </el-date-picker>
        <div class="rmb">
          <el-input v-model="query.min_price" clearable :placeholder="$language('最低人民币')"
            style="width: 160px; margin-right: 10px" />
          <span style="font-size: 14px; color: #000">{{ $language('到') }}</span>
          <el-input v-model="query.max_price" clearable :placeholder="$language('最高人民币')"
            style="width: 160px; margin-left: 10px" />
        </div>
      </div>
      <div>
        <el-button style="margin:0 10px 10px 0;" type="primary" icon="el-icon-search" @click="search">{{
          $language('搜索')
        }}</el-button>
        <el-button style="margin:0 10px 10px 0;" type="primary" icon="el-icon-refresh" @click="init()">{{
          $language('刷新')
        }}</el-button>
        <el-button style="margin:0 10px 10px 0;" type="primary" icon="el-icon-plus"
          @click="(dialogVisible = true, id = '')">{{ $language('添加') }}
        </el-button>
        <el-button style="margin:0 10px 10px 0;" type="primary" @click="status(ids, null, 1)">{{ $language('上架') }}
        </el-button>
        <el-button style="margin:0 10px 10px 0;" type="primary" @click="status(ids, null, 0)">{{ $language('下架') }}
        </el-button>
        <el-button style="margin:0 10px 10px 0;" type="primary" @click="hits(ids, null, 1)">{{ $language('热门') }}
        </el-button>
        <el-button style="margin:0 10px 10px 0;" type="primary" @click="hits(ids, null, 0)">{{ $language('取消热门') }}
        </el-button>
        <el-button style="margin:0 10px 10px 0;" type="primary" @click="del">{{ $language('删除') }}
        </el-button>
      </div>

      <el-table :data="list" ref="" border :header-cell-style="{ background: '#7EC0EE', color: '#fff' }"
        @selection-change="handleSelectionChange" @sort-change="sort" size="small">
        <el-table-column type="selection"></el-table-column>
        <el-table-column :label="$language('序号')" prop="id" align="center" width="74"></el-table-column>
        <el-table-column :label="$language('商品名称')" align="center" width="200">
          <template slot-scope="scope">
            <el-popover trigger="hover" popper-class="popover" placement="right-start" :offset="10" width="200"
              :visible-arrow="false" v-if="scope.row.complete_cover_img">
              <el-image :src="scope.row.complete_cover_img" style="width: 200px;" fit="contain"
                :preview-src-list="[scope.row.complete_cover_img]"></el-image>
              <div slot="reference" class="name-wrapper">
                {{ scope.row.name }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column :label="$language('商品规格')" prop="specs" align="center" width="200"></el-table-column>
        <el-table-column :label="$language('商品编码')" prop="code" align="center"></el-table-column>
        <el-table-column :label="$language('计价类型')" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row.pricing_type == 2 ? $language('金工石计价') : $language('一口价') }}
          </template>
        </el-table-column>
        <el-table-column :label="$language('商品美元价格')" align="center" width="120">
          <template slot-scope="scope">
            <span style="color:#D9001B">${{ scope.row.price_dollar }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$language('商品人民币价格')" prop="price" align="center" width="120">
          <template slot-scope="scope">
            <span style="color:#D9001B">￥{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$language('商品分类')" prop="first_category_id" align="center" sortable="custom"
          width="120">
          <template slot-scope="scope">
            {{ scope.row.first_category_name }} -
            {{ scope.row.second_category_name }} -
            {{ scope.row.third_category_name }}
          </template>
        </el-table-column>
        <el-table-column :label="$language('商品品牌')" prop="" align="center">
          <template slot-scope="scope">
            {{ scope.row.brand ? scope.row.brand.name : '' }}
          </template>
        </el-table-column>
        <el-table-column :label="$language('点击数')" prop="hits" align="center" sortable="custom" width="100">
        </el-table-column>
        <el-table-column :label="$language('收藏数')" prop="collect_count" align="center" sortable="custom" width="120">
        </el-table-column>
        <el-table-column :label="$language('商品状态')" prop="" align="center">
          <template slot-scope="scope">
            {{ scope.row.status == 1 ? $language('上架') : $language('下架') }}
          </template>
        </el-table-column>
        <el-table-column :label="$language('热门状态')" prop="" align="center">
          <template slot-scope="scope">
            {{ scope.row.is_hot == 1 ? $language('热门') : $language('非热门') }}
          </template>
        </el-table-column>
        <el-table-column :label="$language('创建时间')" prop="create_time" align="center" sortable="custom" width="130">
        </el-table-column>
        <el-table-column :label="$language('更新时间')" prop="update_time" align="center" sortable="custom" width="130">
        </el-table-column>
        <el-table-column :label="$language('操作')" prop="" align="center" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="edit(scope.row)">{{ $language('编辑') }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="block" style="text-align: right;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
          :page-sizes="[10, 20, 50, 100]" background layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
      <!-- 编辑/添加弹窗 -->
      <productDialog v-model="dialogVisible" :id="id" :brandList="brandList" @change="change"></productDialog>
    </div>
  </div>
</template>
<script>
import productDialog from './components/productDialog.vue'
import { lists, batchStatus, jewelryExport, batchTop, jewelryDel } from '@/api/merchant/jewelry.js'
import { jewelrySelect } from '@/api/api.js'
export default {
  components: {
    productDialog
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      ids: [], //选择id的集合
      search_time: [],
      list: [],
      total: 0,
      brandList: [], //品牌列表
      id: '', //珠宝商品id
      detailForm: {},
      query: {
        page: 1,
        list_rows: 10,
        name: '', //商品名称
        pricing_type: '',
        status: '', //状态
        jewelry_brand_id: '', //品牌
        is_hot: '', //热门
        start_time: '',
        end_time: '',
        min_price: '',
        max_price: '',
        order_type: '', //1.创建时间降序 2.创建时间升序3.更新时间降序 4.更新时间升序 5.点击率降序 6.点击量升序 7.收藏量降序 8.收藏量升序 9.一级分类id降序 10.一级分类id升序
      },
      pickerOptions: '',
    }
  },
  created() {
    this.init()
    this.getBranch()
  },
  methods: {
    del() {
      if (!this.ids || this.ids.length == 0) {
        this.$message({
          type: "error",
          message: "请勾选商品",
        })
        return
      }
      let length = this.ids.length
      this.$confirm(`批量删除${length}个商品?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          jewelryDel({ids:this.ids}).then((res) => {
            if (res.code == 10000) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.init();
            }
          })
        })
        .catch(() => { })
    },
    dateFocus() {
      this.pickerOptions = {
        shortcuts: [
          {
            text: this.$language('最近一周'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$language('最近一个月'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$language('最近三个月'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      }
    },
    // 品牌下拉
    getBranch() {
      jewelrySelect().then(res => {
        res.data.forEach(item => {
          let obj = {}
          obj.name = item.name
          obj.id = item.id
          this.brandList.push(obj)
        })
      })
    },
    // 获取珠宝商品列表
    init() {
      this.loading = true
      lists(this.query).then(res => {
        this.loading = false
        this.list = res.data.data
        this.total = res.data.total
      }).catch(() => {
        this.loading = false
      })
    },
    //搜索
    search() {
      if (this.query.min_price && isNaN(this.query.min_price)) {
        this.$message.error(this.$language('请输入正确的最小人民币金额'));
        return;
      }
      if (this.query.max_price && isNaN(this.query.max_price)) {
        this.$message.error(this.$language('请输入正确的最大人民币金额'));
        return;
      }
      if (
        this.query.min_price &&
        this.query.max_price &&
        this.query.max_price * 1 <= this.query.min_price * 1
      ) {
        this.$message.error(this.$language('最大人民币金额必须大于最小人民币金额'));
        return;
      }
      this.query.page = 1;
      this.init();
    },
    // 编辑
    edit(row) {
      this.dialogVisible = true
      this.id = row.id
    },
    change(val) {
      if (val) {
        this.query.page = 1
      }
      this.init()
    },
    // 选择时间
    change_time(e) {
      if (e) {
        this.query.start_time = e[0]
        this.query.end_time = e[1]
      } else {
        this.query.start_time = ''
        this.query.end_time = ''
      }
    },
    handleSizeChange(val) {
      this.query.list_rows = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.init();
    },
    // 多选
    handleSelectionChange(val) {
      if (val && val.length != 0) {
        let arr = []
        val.forEach(item => {
          arr.push(item.id)
        })
        this.ids = arr
      } else {
        this.ids = []
      }
    },
    // 上下架
    status(ids, row, status) {
      if (!ids || ids.length == 0) {
        this.$message({
          message: this.$language('请先选择珠宝商品'),
          type: "error",
        });
        return;
      }
      this.loading = true;
      batchStatus({ ids, status: row ? (row.status == 1 ? 0 : 1) : status == 1 ? 1 : 0, }).then((res) => {
        if (res.code == 10000) {
          this.$message({
            message: row
              ? row.status == 1
                ? `${this.$language('商品品牌')}：${row.cert_no} ${this.$language('已下架')}`
                : `${this.$language('商品品牌')}：${row.cert_no} ${this.$language('已上架')}`
              : `${this.$language('已全部')} ${status == 1 ? this.$language('上架') : this.$language('下架')}`,
            type: row
              ? row.status == 1
                ? "error"
                : "success"
              : status == 1
                ? "success"
                : "error",
          });
          this.init();
        }
      })
        .catch((e) => {
          this.loading = false;
        });
    },
    // 热门
    hits(ids, row, status) {
      if (!ids || ids.length == 0) {
        this.$message({
          message: this.$language('请先选择珠宝商品'),
          type: "error",
        });
        return;
      }
      this.loading = true;
      batchTop({ ids, is_hot: row ? (row.status == 1 ? 0 : 1) : status == 1 ? 1 : 0, }).then((res) => {
        if (res.code == 10000) {
          this.$message({
            message: row
              ? row.status == 1
                ? `${this.$language('商品品牌')}： ${row.cert_no} ${this.$language('已取消热门')}`
                : `${this.$language('商品品牌')}： ${row.cert_no} ${this.$language('已设置为热门')}`
              : `${this.$language('已全部')} ${status == 1 ? this.$language('设置为热门') : this.$language('取消热门')}`,
            type: row
              ? row.status == 1
                ? "error"
                : "success"
              : status == 1
                ? "success"
                : "error",
          });
          this.init();
        }
      })
        .catch((e) => {
          this.loading = false;
        });
    },
    // 排序
    sort(e) {
      switch (e.order) {
        //升序
        case "ascending":
          switch (e.prop) {
            case 'first_category_id':
              this.query.order_type = 10
              break;
            case 'collect_count':
              this.query.order_type = 8
              break;
            case 'hits':
              this.query.order_type = 6
              break;
            case 'create_time':
              this.query.order_type = 2
              break;
            case 'update_time':
              this.query.order_type = 4
              break;
            default:
          }
          break;
        //降序
        case "descending":
          switch (e.prop) {
            case 'first_category_id':
              this.query.order_type = 9
              break;
            case 'collect_count':
              this.query.order_type = 7
              break;
            case 'hits':
              this.query.order_type = 5
              break;
            case 'create_time':
              this.query.order_type = 1
              break;
            case 'update_time':
              this.query.order_type = 3
              break;
            default:
          }
          break;
        //默认
        default:
          this.query.order_type = ''
      }
      this.query.page = 1;
      this.init();
    },
  }
}
</script>
<style>
.popover {
  border: 0;
  padding: 0px;
  box-shadow: none;
  border-radius: 0;
  line-height: 0;
  background: none;
}
</style>
<style lang="scss" scoped>
::v-deep .el-table .ascending .sort-caret.ascending {
  border-bottom-color: #fff !important;
}

::v-deep .el-table .descending .sort-caret.descending {
  border-top-color: #fff !important;
}

.rmb {
  display: flex;
  align-items: center;
  height: 36px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 10px;

  ::v-deep .el-input__inner {
    height: 32px;
    border-color: rgba(0, 0, 0, 0);
    text-align: center;
  }
}

::v-deep .el-table .caret-wrapper {
  width: 14px;
}
</style>